import React, { useEffect, useRef, useState } from 'react';

// Visual 4: the five D's on one horizontal line that draws itself once as it scrolls into view.
const STEPS = [
  { word: 'Diagnose', text: 'We assess the people and the conditions around the decision and build the picture.' },
  { word: 'Decide', text: 'We take your executive team through what we found, in person, and the team decides what to do about it.' },
  { word: 'Develop', text: 'Coaching, leadership development and the companion support the people the decision depends on.' },
  { word: 'Deploy', text: 'Hiring, appraisal and succession decisions start using the evidence.' },
  { word: 'Demonstrate', text: 'A quarterly review, the year-end 360 and a re-measure show what has moved.' },
];

export const EngagementFlow = () => {
  const ref = useRef(null);
  const [drawn, setDrawn] = useState(false);

  useEffect(() => {
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) { setDrawn(true); return; }
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { setDrawn(true); obs.unobserve(e.target); } });
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} data-testid="engagement-flow">
      {/* Desktop: horizontal line that draws itself */}
      <div className="hidden md:block relative">
        <div className="absolute top-[7px] left-0 right-0 h-px bg-slate-200" aria-hidden="true" />
        <div
          className="absolute top-[7px] left-0 h-px bg-[#2693d0] origin-left"
          style={{ right: 0, transform: drawn ? 'scaleX(1)' : 'scaleX(0)', transition: 'transform 1.2s ease-out' }}
          aria-hidden="true"
        />
        <div className="relative grid grid-cols-5 gap-6">
          {STEPS.map((s) => (
            <div key={s.word}>
              <div className="w-3.5 h-3.5 rounded-full bg-[#2693d0] mb-5" aria-hidden="true" />
              <h3 className="text-slate-900 font-semibold text-base mb-2">{s.word}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile: stacked */}
      <div className="md:hidden space-y-6">
        {STEPS.map((s) => (
          <div key={s.word} className="flex gap-4">
            <div className="w-3 h-3 rounded-full bg-[#2693d0] mt-1.5 flex-shrink-0" aria-hidden="true" />
            <div>
              <h3 className="text-slate-900 font-semibold text-base mb-1">{s.word}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{s.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EngagementFlow;
